import React from "react";
import CpntHeaderBO from "../CpntHeaderBO";
import CpntFooterBO from "../CpntFooterBO";
import { Outlet, useLocation } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

const BoLayout: React.FC = () => {

  const contenuAEditer = null;
  const location = useLocation();
  const isDecoMode = location.pathname === '/admin' || location.pathname === '/admin/';

  return (
    <div >
      <CpntHeaderBO />
        {isDecoMode ? 
          (
            <div className="App-body-BO-Deconnecte">
              <Outlet />
            </div>
          ) 
          :
          ( 
            <div className="App-body-BO-Connecte">
              <Container >
                <Row>
                  {/* <Col>&nbsp;</Col> */}
                  <Col xs={12}>    
                    <div
                    id={`${contenuAEditer ? "edit-layout-mode" : ""}`}
                    className={"container"}
                  >
                    <div className="row">
                      {contenuAEditer && ( 
                        //contenuAEditer?.Id 
                        <div className="col-4 card edit-layout-control sticky-top margin-top-sticky ">
                          {/* <EditLayout /> */}
                        </div>
                      )}
                      <div
                        className={`col App-content-wrapper product-page ${
                          contenuAEditer ? "edit-layout-contenu" : ""
                        }`}
                      >
                        <Outlet />
                      </div>
                    </div>
                  </div>
                  </Col>
                </Row>
              </Container>
            </div>
          )
        }
      <CpntFooterBO />
      </div>
  );
};

export default BoLayout;
